import React from 'react';

// Matches http(s)://... and www.... up to whitespace.
// Conservative: stops at whitespace; trailing punctuation is trimmed afterwards.
const URL_RE = /((?:https?:\/\/|www\.)[^\s]+)/gi;

// Trailing punctuation that typically belongs to the surrounding sentence, not the URL.
const TRAILING_PUNCT = /[)\].,;:!?，。！？、）】]+$/;

const splitTrailing = (token) => {
  const m = token.match(TRAILING_PUNCT);
  if (!m) return [token, ''];
  const idx = token.length - m[0].length;
  return [token.slice(0, idx), token.slice(idx)];
};

const normalizeHref = (token) => {
  if (/^https?:\/\//i.test(token)) return token;
  return `https://${token}`;
};

// Render a plain-text string as React children with any URLs turned into <a> links.
// Usage: {linkify(t.text)}
export function linkify(text) {
  if (text == null) return text;
  const str = String(text);
  if (!str) return str;

  const parts = [];
  let lastIdx = 0;
  let key = 0;
  URL_RE.lastIndex = 0;
  let m;
  while ((m = URL_RE.exec(str)) !== null) {
    const matched = m[0];
    const start = m.index;
    if (start > lastIdx) {
      parts.push(str.slice(lastIdx, start));
    }
    const [urlPart, trailing] = splitTrailing(matched);
    const href = normalizeHref(urlPart);
    parts.push(
      React.createElement(
        'a',
        {
          key: `lk-${key++}`,
          href,
          target: '_blank',
          rel: 'noopener noreferrer',
          onClick: (e) => e.stopPropagation(),
        },
        urlPart,
      ),
    );
    if (trailing) parts.push(trailing);
    lastIdx = start + matched.length;
  }
  if (lastIdx < str.length) parts.push(str.slice(lastIdx));
  return parts.length ? parts : str;
}
